var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIpAddressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ip-address") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "expermentation-v02",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.0-additional-details",
    transform: "translate(-31.000000, -508.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(16.000000, 488.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ip-address",
    transform: "translate(15.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C5.37257143,0 0,5.37257143 0,12 C0,12.4731429 0.384,12.8571429 0.857142857,12.8571429 C1.33028571,12.8571429 1.71428571,12.4731429 1.71428571,12 C1.71428571,6.31971429 6.31971429,1.71428571 12,1.71428571 C17.6802857,1.71428571 22.2857143,6.31971429 22.2857143,12 C22.2857143,12.4731429 22.6688571,12.8571429 23.1428571,12.8571429 C23.6168571,12.8571429 24,12.4731429 24,12 C24,5.37257143 18.6274286,0 12,0",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,4.28571429 C7.73914286,4.28571429 4.28571429,7.73914286 4.28571429,12 C4.28571429,12.4731429 4.66971429,12.8571429 5.14285714,12.8571429 C5.616,12.8571429 6,12.4731429 6,12 C6,8.68628571 8.68628571,6 12,6 C15.3137143,6 18,8.68628571 18,12 C18,12.4731429 18.3831429,12.8571429 18.8571429,12.8571429 C19.3311429,12.8571429 19.7142857,12.4731429 19.7142857,12 C19.7142857,7.73914286 16.2608571,4.28571429 12,4.28571429",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.428589,12 C15.4345714,10.1065714 13.9045714,8.56628571 12.0111429,8.56026813 C10.1177143,8.55428571 8.57742857,10.0842857 8.57140991,11.9777143 C8.56628571,13.5454286 9.62485714,14.9168571 11.1428571,15.3085714 L11.1428571,22.2857143 L9.42857143,22.2857143 C8.95542857,22.2857143 8.57140991,22.6688571 8.57140991,23.1428571 C8.57140991,23.6168571 8.95542857,24 9.42857143,24 L14.5714286,24 C15.0454286,24 15.428589,23.6168571 15.428589,23.1428571 C15.428589,22.6688571 15.0454286,22.2857143 14.5714286,22.2857143 L12.8571429,22.2857143 L12.8571429,15.3085714 C14.3674286,14.9185714 15.4234286,13.5591429 15.428589,12",
    id: "Fill-5"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpAddressIcon);
export default __webpack_public_path__ + "static/media/ip-address-icon.9bba80ec2b953289a39f9a1ac8411021.svg";
export { ForwardRef as ReactComponent };